import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { getImage, GatsbyImage } from 'gatsby-plugin-image'

import { links } from "src/constants"
import { AppleButton } from './buttons/AppleButton'
import { GooglePlayButton } from './buttons/GooglePlayButton'
import { QRCode } from './buttons/QRCode'


interface OwnProps {
  useQRCode: boolean
}

type AppStoreButtonsProps = OwnProps

export const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
  useQRCode = false
}) => {
  const imageQuery = useStaticQuery(graphql`
    query FooterAppStoreButtons {
      appleBadge: file(
        relativePath: { eq: "app-store-buttons/apple-app-store-badge.svg" }
      ) {
        publicURL
      },
      googlePlayBadge: file(
        relativePath: { eq: "app-store-buttons/google-play-badge.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 150)
        }
        publicURL
      }
      qrCode: file(
        relativePath: { eq: "legacy/appStoreButtons/b8nu581a_qr_code.png" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const googleImage = getImage(imageQuery.googlePlayBadge)

  const fireAnalyticsCall = (platform: string): void => {
    analytics.track("Download Button Clicked", {
      os: platform,
    })
  }

  const appleStoreLink = links.appleAppStore;
  const googleStoreLink = links.googlePlayStore

  return (
    <div className="mt-5 justify-center items-center md:justify-normal">
      <div className="md:hidden">
        <AppleButton onButtonClick={fireAnalyticsCall} src={imageQuery.appleBadge.publicURL} storeLink={appleStoreLink} />
        <GooglePlayButton imageData={googleImage} onButtonClick={fireAnalyticsCall} storeLink={googleStoreLink} />
      </div>
      {useQRCode && (
        <div className="hidden md:block">
          <AppleButton src={imageQuery.appleBadge.publicURL} />
          <GooglePlayButton imageData={googleImage} />
          <QRCode imageData={imageQuery.qrCode.childImageSharp.gatsbyImageData} />
        </div>
      )}
    </div>
  )
}
